export default __webpack_public_path__ + "static/media/prescription.34e8ee17.png";